import { Typography } from '@mui/material';
import MyTable, { MyTableHeader, MyTableBody, MyTableRow, MyTableCol } from 'components/MyTable';
import React, { useCallback } from 'react';
import QuickViewDefault from 'v2/components/Shared/QuickView';
import Truncate from 'v2/components/Shared/TruncateText';
import { dateFormat } from 'v2/formatters/date';
import { InvoiceStatus, SubscriptionStatus } from 'v2/interfaces/webhook2';

import type { WebhookHistory } from 'v2/interfaces/webhook2';

import styles from '../styles';

type IProps = {
  webhook: WebhookHistory;
  open: boolean;
  handleClose: () => void;
};

export const QuickView = ({ webhook, open, handleClose }: IProps) => {
  const classes = styles();

  const indexes = [
    { title: 'Code', ordering: false },
    { title: 'Resposta', ordering: false },
    { title: 'Data', ordering: false },
  ];

  const solveStatusColor = useCallback((status: string): string => {
    const statusInt = Number.parseInt(status);

    if (statusInt >= 200 && statusInt < 300) {
      return 'status-200';
    }

    return 'status-504';
  }, []);
  const historic = webhook?.sends || [];
  const sent = webhook?.sentData ? JSON.stringify(JSON.parse(webhook.sentData), undefined, 2) : '';

  return (
    <QuickViewDefault title='Detalhes do Webhook' open={open} onClose={handleClose}>
      <Typography sx={{ mb: 1.5 }} color='text.secondary'>
        <strong>URL</strong>
        <div>{webhook?.url}</div>
      </Typography>
      <Typography sx={{ mb: 1.5 }} color='text.secondary'>
        <Truncate count={50} final='...' title={webhook?.product.title}>
          <strong>Produto</strong>
          <div>{webhook?.product.id !== -1 && `(${webhook?.product.id}) ${webhook?.product.title}`}</div>
        </Truncate>
      </Typography>
      <Typography sx={{ mb: 1.5 }} color='text.secondary'>
        <Truncate count={25} final='...' title={webhook?.customer.name}>
          <strong>Comprador</strong> <div>{webhook?.customer.name}</div>
        </Truncate>
      </Typography>

      {webhook?.type === 'invoice' && (
        <Typography sx={{ mb: 1.5 }} color='text.secondary'>
          <div>
            <strong>Fatura</strong>
            <div>
              {webhook?.entityId} - {InvoiceStatus[webhook.entityStatus] ?? ''}
            </div>
          </div>
        </Typography>
      )}

      {webhook?.type === 'contract' && (
        <Typography sx={{ mb: 1.5 }} color='text.secondary'>
          <div>
            <strong>Contrato</strong>
            <div>
              {webhook?.entityId} - {SubscriptionStatus[webhook?.entityStatus]}
            </div>
          </div>
        </Typography>
      )}

      <div className={classes.historic}>
        <div className='title'>Histórico de envios</div>
        <div className='content'>
          {historic.length === 0 && <div className='not-found'>Nenhum histórico encontrado.</div>}

          {historic.length > 0 && (
            <div className='table'>
              <MyTable>
                <MyTableHeader index={indexes} />

                <MyTableBody>
                  {historic.map((item) => (
                    <MyTableRow key={item._id}>
                      <MyTableCol screenSizes={{ xs: 12, sm: 12 }} mobileOrder={1}>
                        <span className={`${classes.httpStatus} ${solveStatusColor(item.returnStatus)}`}>{item.returnStatus}</span>
                      </MyTableCol>
                      <MyTableCol screenSizes={{ xs: 12, sm: 12 }} mobileOrder={2}>
                        <Truncate count={20} final={'...'}>
                          {item.returnData}
                        </Truncate>
                      </MyTableCol>
                      <MyTableCol screenSizes={{ xs: 12, sm: 12 }} mobileOrder={3}>
                        {dateFormat(item.created_at, 'dd/MM/yyyy, HH:mm:ss')}
                      </MyTableCol>
                    </MyTableRow>
                  ))}
                </MyTableBody>
              </MyTable>
            </div>
          )}
        </div>
      </div>

      <div className={classes.data}>
        <div className='title'>Dados enviados</div>
        <div className='content'>
          <pre>{sent}</pre>
        </div>
      </div>
    </QuickViewDefault>
  );
};
